<script>
export default {
  data () {
    return {
      registrationSymbolSet: [],
      ownerCodeSet: [],
      modelCodeSet: []
    }
  },
  methods: {
    loadRegistrationSymbol () {
      this.$axios
        .get('/search-registration-symbol')
        .then((res) => {
          const result = res.data.list
          const registrationSymbolSet = new Set()
          const ownerCodeSet = new Set()
          const modelCodeSet = new Set()
          result.forEach((x) => {
            registrationSymbolSet.add(x.registration_symbol)
            ownerCodeSet.add(x.owner_code)
            modelCodeSet.add(x.model_code)
          })
          this.registrationSymbolSet = [...registrationSymbolSet]
          this.ownerCodeSet = [...ownerCodeSet]
          this.modelCodeSet = [...modelCodeSet]
          sessionStorage.setItem('registrationSymbolSet', JSON.stringify(this.registrationSymbolSet))
          sessionStorage.setItem('ownerCodeSet', JSON.stringify(this.ownerCodeSet))
          sessionStorage.setItem('modelCodeSet', JSON.stringify(this.modelCodeSet))
        })
        .catch((e) => {
          console.log(e)
        })
    },
    refreshRegistrationSymbolAutocompleteList () {
      this.registrationSymbolSet = JSON.parse(sessionStorage.getItem('registrationSymbolSet'))
      this.ownerCodeSet = JSON.parse(sessionStorage.getItem('ownerCodeSet'))
      this.modelCodeSet = JSON.parse(sessionStorage.getItem('modelCodeSet'))
    },
    getRegistrationSymbolSet () {
      return JSON.parse(sessionStorage.getItem('registrationSymbolSet'))
    },
    getOwnerCodeSet () {
      return JSON.parse(sessionStorage.getItem('ownerCodeSet'))
    },
    getModelCodeSet () {
      return JSON.parse(sessionStorage.getItem('modelCodeSet'))
    },
    margeRegistrationSymbolSet (value) {
      const newRegistrationSymbolSet = Array.isArray(value) ? [...value] : [value]
      const registrationSymbolSet = [...new Set([...JSON.parse(sessionStorage.getItem('registrationSymbolSet')),
        ...newRegistrationSymbolSet])].sort()
      sessionStorage.setItem('registrationSymbolSet', JSON.stringify([...registrationSymbolSet]))
    },
    margeOwnerCodeSet (value) {
      const newOwnerCodeSet = Array.isArray(value) ? [...value] : [value]
      const ownerCodeSet = [...new Set([...JSON.parse(sessionStorage.getItem('ownerCodeSet')),
        ...newOwnerCodeSet])].sort()
      sessionStorage.setItem('ownerCodeSet', JSON.stringify([...ownerCodeSet]))
    },
    margeModelCodeSet (value) {
      const newModelCodeSet = Array.isArray(value) ? [...value] : [value]
      const modelCodeSet = [...new Set([...JSON.parse(sessionStorage.getItem('modelCodeSet')),
        ...newModelCodeSet])].sort()
      sessionStorage.setItem('modelCodeSet', JSON.stringify([...modelCodeSet]))
    }
  }
}
</script>
